module.exports = __webpack_public_path__ + "static/media/tradeThumbnail.c2f767b4.PNG";